const DAY_IN_MS = 24 * 60 * 60 * 1000;

/**
 * How long a container stood, in whole days: elapsed time up to the end, or up to now while it is
 * still standing. Counts elapsed days rather than calendar days, so a container placed yesterday
 * evening and collected this morning reads as under a day instead of two.
 */
// @ai-generated 2026-08-27T11:34:55+00:00 by kai.cissarek@synqony.com using Claude Opus 5
export function getStandingDurationLabel(
    startedAt: string | undefined,
    endedAt: string | undefined,
    now: Date = new Date(),
): string {
    if (!startedAt) {
        return '';
    }

    const start = new Date(startedAt).getTime();
    if (Number.isNaN(start)) {
        return '';
    }

    const end = endedAt ? new Date(endedAt).getTime() : now.getTime();
    if (Number.isNaN(end)) {
        return '';
    }

    // A clock skew between the writer and the reader can date a fresh row a moment ahead of now.
    const days = Math.max(0, Math.floor((end - start) / DAY_IN_MS));

    if (days === 0) {
        return 'unter 1 Tag';
    }

    return days === 1 ? '1 Tag' : `${days} Tage`;
}
